import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
// import { EventEmitter } from 'events';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap'; 
import { DataService } from "../../services/data.service";
import { APIService } from '../../api.service';
import { SelectStoreComponent } from '../select-store/select-store.component';


@Component({
  selector: 'app-multiple-select-item',
  templateUrl: './multiple-select-item.component.html',
  styleUrls: ['./multiple-select-item.component.scss']
})
export class MultipleSelectItemComponent implements OnInit {
  
  @Input() typeID: number = 0;
  @Input() it: any = []; 
  @Input() st: number = 0;
  @Input() ft: number = 1;
  @Input() stc: boolean = true;
  @Input() isMade: number = 0;
  @Input() rm: number = 0;
  @Input() ri: number = 0;
  @Input() mdlRef: any;
  modalReference: any;
  @Input() invoiceID: number = 0;
  @Input() invouceStoreID: number = 0;
  @Input() prTypeID: number = 1;
  @Input() showSupStore: boolean = false;
  // @Input() isFromProjectMod: boolean = false;

  items: any[] = [];
  selectedItemCount: number = 0;
  //storeId: number = 0;
  jarvisData: any = [];
  data: any = [];
  stores: any[] = [];
  configData: any = [];
  MTbl: any = [];
  isStoreSelected: boolean = false;
  store = {
    id: -1,
    name: ''
  }

  isProuction: number = this.isMade;
  
  //storeName: string = '';
  search: string = '';
  ERP_Cfg: any = [];
  catagories: any = [];
  firstTime: boolean = true;
  innerWidth: any;
  isMobileView: boolean = false;

  constructor(private _Activatedroute: ActivatedRoute, private router: Router, private modalService: NgbModal, private appService: DataService, private apiService: APIService) { }
  
  ngOnInit(): void {
    
    //If typeID == 1 : From Dispatch
    //If typeID == 2 : Store transfer
    //If typeID == 3 : Issue Direct
    //If typeID == 4 : Return Direct
    //If typeID == 5 : GNR
    //IF typeID == 6 : from issue for production


    //If rm == 0 : all Item
    //If rm == 1 : raw material

    //If st == 0 : store not selected
    //If st > 0 : store selected

    //If ft == 1 : Display Store

    //If it : SelectedItems

    //If stc : can change store

    //If ri remove item

    //if prTypeID or isFromProjectMod : From Project Module

    //this.stores = [{ id: 1, name: 'Home' }, { id: 2, name: 'Godown' }, { id: 3, name: "Deep's home" }, { id: 4, name: "Jaimin's home" }, { id: 5, name: "Abhishek's home" }];

    var tblM = this.apiService.getCookie("M");
    if(tblM) {
      this.MTbl = JSON.parse(tblM);
    }

    let tmpERP_Cfg = this.apiService.getCookie("ERP_Cfg");
    if(tmpERP_Cfg) {
      this.ERP_Cfg = JSON.parse(tmpERP_Cfg);
      if(this.ERP_Cfg[0].ItemCategories) {
        this.catagories = JSON.parse(this.ERP_Cfg[0].ItemCategories);
      }
    }
    this.getData();

    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 1000) {
        this.isMobileView = true;
    }
  }

  ngAfterViewInit(): void {
    if (this.isMobileView){
      let height = (document.querySelector(".fixedTitle") as HTMLElement).offsetHeight + "px";
      (document.querySelector(".itemList") as HTMLElement).style.setProperty('margin-top', height);
    }
  }

  getData() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }     

    this.getStores();
    if(this.ft == 0 || this.typeID == 5 || this.typeID == 4){
      this.getItems();
    }
    
  }

  getItems(){
    
    let data = [{
      StatusID: 1,
      // StoreID: 0
      StoreID: this.ft == 0 ? 0 : this.typeID == 5 || this.typeID == 4 ? 0 : this.store.id,
      changeType: this.prTypeID == 2 ? 'PRJTYPE' : ''
    }];
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.MTbl[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'get',
      moduleID: 5,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successItemResp.bind(this), this.failureResp.bind(this));
  }

  getStores() {
    let data = [{
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.MTbl[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'getConfig',
      moduleID: 6,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successConfigResp.bind(this), this.failureResp.bind(this));
  }

  //successItemResp - success  get handler
  successItemResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
            this.data = reponseData;
            this.items = this.data.Table1;
            this.items = this.items.filter((o: any) => o.IsActive ? o.IsActive : 0);
            if (this.prTypeID == 1) {
              this.items = this.items.filter((item: any) => item.TypeID != 6);

              if(this.store.id == 0) {
                this.apiService.setIDB('erp_inv', this.items);
              }

              if(this.typeID == 1 || this.typeID == 2 || this.typeID == 3){
                this.items = this.items.filter((o: any) => o.CurrQty > 0)
              };
              
              this.items.forEach((element: any) => {
                element.isSelected = false;
                element.Bom = false;
                element.CurrQty = Number(element.CurrQty).toFixed(element.SKUPrecision);
                element.StoreItemQty = Number(element.StoreItemQty).toFixed(element.SKUPrecision);
                if(element.StoreBatches) {
                  element.StoreBatches = JSON.parse(element.StoreBatches);
                  // To get selected store qty.
                  if(element.StoreBatches.length > 0) {
                    let tmpQty = element.StoreBatches.filter((a: any) => { return a.SID == this.store.id });
                    if(tmpQty.length > 0){
                      element.StoreItemQty = tmpQty[0].Q;
                    } else {
                      element.StoreItemQty = 0;
                    }
                    element.CurrQty = Number(element.CurrQty).toFixed(element.SKUPrecision),
                    element.StoreItemQty = Number(element.StoreItemQty).toFixed(element.SKUPrecision)
                  }
                }
                else{
                  element.StoreBatches = [];
                }
              });
            }
            else {
              this.items = this.items.filter((item: any) => item.TypeID == 6);
            }
            
            if(this.isProuction == 1) {
              this.items = this.items.filter((o: any) => o.IsMade == true);
            }

            if(this.rm == 1) {
              this.items = this.items.filter((o: any) => o.TypeID == 2);
            }

            if(this.ri > 0) {
              this.items = this.items.filter((o: any) => o.ItemID != this.ri);
            }
            
            this.items = this.items.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));

            this.items.forEach((a: any) => {
              this.catagories.forEach((b: any) => {
                if(a.CID == b.cid){
                  a.CN = b.cnm;
                  if(b.sub) {
                    b.sub.forEach((c: any) => {
                      if(a.SCID == c.sid) {
                        a.SC = c.snm;
                      }
                    });
                  } 
                }
              });
            })
            // Display Selected Items
            if(this.it.length > 0) {
              this.it.forEach((e: any) => {
                this.items.forEach((f: any) => {
                  if(f.ItemID == e) {
                    f.isSelected = true;
                  }
                });
              });

              this.getSelectedItemCount();
            }
        }
      }
    }
  }

  //successConfigResp - success  get handler
  successConfigResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
            let cData = reponseData.Table2
            let tmpStore = cData[0].Stores;
            this.stores = JSON.parse(tmpStore);
            if (this.showSupStore) {
              this.stores = this.stores.filter((store: any) => store.hasOwnProperty('IsJobStr') && store.IsJobStr);
            }

            if(this.jarvisData[0].UserID != this.MTbl[0].AdminUserID){
              tmpStore = this.stores;
              this.stores = [];
              for(let i: number = 0; i < tmpStore.length; i++){
                if(tmpStore[i].UIDs){
                  let selectedUsers = String(tmpStore[i].UIDs).split(",");
                  for(let j: number = 0; j < selectedUsers.length; j++){
                    if(selectedUsers[j] == this.jarvisData[0].UserID){
                      this.stores.push(tmpStore[i]);
                    }
                  }                
                }
                else{
                  this.stores.push(tmpStore[i]);
                }
              }
            }

            if(this.stores.length == 1){
              this.store.id = this.stores[0].StrID;
              this.selectStoreDropdown();
            }
            else{
              this.store.id = -1;
            }
            if(this.st > 0){
              this.isStoreSelected = true;
              this.store.id = this.stores.filter((a: any) => a.StrID == this.st)[0].StrID;
              this.store.name = this.stores.filter((a: any) => a.StrID == this.st)[0].sNm;
              // if(this.stores.length == 1){
              //   this.store.id = this.stores[0].StrID;
              // }
              // else{
              //   this.store.id = -1;
              // }
              this.getItems();
            } 
            else {
              // this.store.id = 0;
              // this.store.name = 'All Stores';
              //this.getItems();
            }
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }
 
 
  selectItem(obj: any) {
    if(this.prTypeID == 2){
      // this.isFromProjectModlue = true;
      this.items.forEach((element: any) => {
        element.isSelected = false;
      });
      obj.isSelected = true;
      this.getSelectedItemCount();
    }
    else{
      obj.isSelected = !obj.isSelected;
      this.getSelectedItemCount();
    }
  }

  getSelectedItemCount() {
    this.selectedItemCount = this.items.filter((i: any) => i.isSelected == true).length;
  }

  select() {
    if((this.ft == 1) && (this.store.id == -1)){
      this.apiService.successAlert('Please select store first.');
      return;
    }

    let selectedItems = this.items.filter((i: any) => i.isSelected == true);
    if(selectedItems.length == 0) {
      this.apiService.successAlert('Please select item.');
      return;
    }
    selectedItems.forEach((element: any) => {
      element.Batches = [];
      element.hasBatches = false;
      element.BatchType = element.BatchType ? element.BatchType : 0;
    });
    this.appService.updateItems(selectedItems);
    this.appService.updateStore(this.store);
    this.closeModal();
    if(this.typeID == 6) {
      this.router.navigate(['transactionJobs', { id: this.typeID }]);
    }

    else if(this.typeID == 1 || this.typeID == 2 || this.typeID == 3 || this.typeID == 4 || this.typeID == 5 || this.typeID == 7 || this.typeID == 8) {
      if (this.invoiceID > 0) {
        this.router.navigate(['transfer', { id: this.typeID, sid: this.invouceStoreID, invID: this.invoiceID }]);
      }
      else{
        this.router.navigate(['transfer', { id: this.typeID }]);
      }
      
    }
    
  }

  closeModal() {
    this.mdlRef.close();
  }

  selectStore(content: any) {
    //this.modalReference = this.modalService.open(content);

    //If can change store
    if(this.stc){
      this.modalReference = this.modalService.open(SelectStoreComponent, { backdrop: 'static', keyboard: false });
      this.modalReference.componentInstance.StoreID = this.store.id; 
      this.modalReference.componentInstance.AllOption = 0; 
      this.modalReference.componentInstance.mdlRef = this.modalReference; 
      this.modalReference.result.then((result: any) => {
         if (result) {
           if(result.length > 0) {
             this.st = result[0].StrID;
             this.store.id = result[0].StrID;
             this.store.name = result[0].sNm;
             this.isStoreSelected = true;
             this.firstTime = false;
             if((this.typeID == 4) || (this.typeID == 5)) {
              //this.getItems();
             } else {
              this.getItems();
             }
             
           }
         }
       });
    }
  }

  selectStoreDropdown() {
 
    let tmpStr = this.stores.filter((a: any) => a.StrID == this.store.id);

    this.st = tmpStr[0].StrID;
    this.store.id = tmpStr[0].StrID;
    this.store.name = tmpStr[0].sNm;
    this.isStoreSelected = true;
    this.firstTime = false;
    if((this.typeID == 4) || (this.typeID == 5)) {
    //this.getItems();
    } else {
    this.getItems();
    }
  }

  back() {
    this.mdlRef.close();
  }
  
  goBack() {
    let doneObj = {
      action: 'Done',
      obj: ''
    }
    this.mdlRef.close(doneObj);
  }
}
